(() => {
  if (window.WTMCartDrawer) {
    window.WTMCartDrawer.mount();
    return;
  }

  const ROOT = window.Shopify?.routes?.root || '/';
  const CDN = 'https://cdn.shopify.com/s/files/1/0919/5264/4409/files/';

  /*
    Product ID, title, Buy 1–10 variants,
    advertised USD prices, original prices, image.
  */
  const rows = [
    [
      10335022055737,
      'I F*cking Need You Ring',
      [54461049897273, 54461049930041, 54461049962809, 67638551445817, 67638551478585, 67638551511353, 67638551544121, 67638551576889, 67638551609657, 67638551642425],
      [3499, 5499, 7499, 9999, 12499, 14999, 17499, 19999, 22499, 24999],
      [6999, 13999, 20999, 23499, 25999, 28499, 30999, 33499, 35999, 38499],
      '1_64888ec6-f96b-4f4c-a8f7-90033c248561.png?v=1789179342'
    ],
    [
      10335022252345,
      'Strength Within Ring',
      [54466090795321, 54466090828089, 54466090860857, 67638548037945, 67638548070713, 67638548103481, 67638548136249, 67638548169017, 67638548201785, 67638548234553],
      [3999, 5999, 8499, 11399, 14199, 16999, 19899, 22699, 25499, 28399],
      [7999, 15999, 23999, 26899, 29699, 32499, 35399, 38199, 40999, 43899],
      '1_5b9b2e5b-0cde-4e77-a88f-c541e76eabb6.png?v=1789179462'
    ],
    [
      10335030542649,
      'Faith Over Fear Ring',
      [54466091385145, 54466091417913, 54466091450681, 67638374891833, 67638374924601, 67638374957369, 67638374990137, 67638375022905, 67638375055673, 67638375088441],
      [3499, 5499, 7499, 9999, 12499, 14999, 17499, 19999, 22499, 24999],
      [6999, 13999, 20999, 23499, 25999, 28499, 30999, 33499, 35999, 38499],
      '1_bbe9e7fa-7f97-42c3-accd-9de70da0571a.png?v=1789179217'
    ],
    [
      10335027167545,
      'Unbreakable Bond Ring',
      [54466091188537, 54466091221305, 54466091254073, 67638524150073, 67638524182841, 67638524215609, 67638524248377, 67638524281145, 67638524313913, 67638524346681],
      [3499, 5499, 7499, 9999, 12499, 14999, 17499, 19999, 22499, 24999],
      [6999, 13999, 20999, 23499, 25999, 28499, 30999, 33499, 35999, 38499],
      '1_5157e2a4-2a0a-448c-aa5d-04d668fe4988.png?v=1789179777'
    ],
    [
      10335024185657,
      'Forever With Me Paw Ring',
      [54466091057465, 54466091090233, 54466091123001, 67638528540985, 67638528573753, 67638528606521, 67638528639289, 67638528672057, 67638528704825, 67638528737593],
      [3499, 5499, 7499, 9999, 12499, 14999, 17499, 19999, 22499, 24999],
      [6999, 13999, 20999, 23499, 25999, 28499, 30999, 33499, 35999, 38499],
      '1_f9d4ce69-9879-49aa-b80e-81a48dd67a70.png?v=1789179576'
    ],
    [
      10335023268153,
      'Always With You Hug Ring',
      [54466090893625, 54466090926393, 54466090959161, 67638536601913, 67638536634681, 67638536667449, 67638536700217, 67638536732985, 67638536765753, 67638536798521],
      [3499, 5499, 7499, 9999, 12499, 14999, 17499, 19999, 22499, 24999],
      [6999, 13999, 20999, 23499, 25999, 28499, 30999, 33499, 35999, 38499],
      '1_971d4ad5-2259-4f8b-9412-293c95e289ef.png?v=1789179677'
    ]
  ];

  const rings = new Map(
    rows.map((row, index) => [
      row[0],
      {
        id: row[0],
        title: row[1],
        variants: row[2],
        offers: row[3],
        retail: row[4],
        image: CDN + row[5],
        index
      }
    ])
  );

  const birthstonePreview = {
    "productId": 15401534030137,
    "baseImage": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-hug-preview-neutral.png?v=1792119620",
    "months": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "overlays": {
      "first": {
        "january": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-first-01-january.png?v=1792119842",
        "february": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-first-02-february.png?v=1792119866",
        "march": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-first-03-march.png?v=1792119879",
        "april": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-first-04-april.png?v=1792119907",
        "may": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-first-05-may.png?v=1792119927",
        "june": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-first-06-june.png?v=1792119939",
        "july": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-first-07-july.png?v=1792119960",
        "august": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-first-08-august.png?v=1792119973",
        "september": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-first-09-september.png?v=1792119986",
        "october": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-first-10-october.png?v=1792120009",
        "november": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-first-11-november.png?v=1792120023",
        "december": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-first-12-december.png?v=1792120035"
      },
      "second": {
        "january": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-second-01-january.png?v=1792119861",
        "february": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-second-02-february.png?v=1792119872",
        "march": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-second-03-march.png?v=1792119884",
        "april": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-second-04-april.png?v=1792119920",
        "may": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-second-05-may.png?v=1792119934",
        "june": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-second-06-june.png?v=1792119945",
        "july": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-second-07-july.png?v=1792119966",
        "august": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-second-08-august.png?v=1792119979",
        "september": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-second-09-september.png?v=1792119995",
        "october": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-second-10-october.png?v=1792120017",
        "november": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-second-11-november.png?v=1792120029",
        "december": "https://cdn.shopify.com/s/files/1/0919/5264/4409/files/wtm-birthstone-preview-second-12-december.png?v=1792120042"
      }
    }
  };
  const singleRingProducts = new Set([birthstonePreview.productId]);

  // Product pairings based on the meaning of each ring.
  const pairings = [
    [5, 3, 1, 2, 4],
    [2, 3, 0, 5, 4],
    [1, 4, 3, 5, 0],
    [5, 0, 1, 2, 4],
    [5, 2, 3, 1, 0],
    [0, 3, 4, 2, 1]
  ];

  const gifts = [
    {
      id: 54466094006585,
      title: 'Note Guide',
      image: CDN + 'Note_Guide.webp?v=1789183954',
      retail: 1000,
      digital: true
    },
    {
      id: 54466091974969,
      title: 'Message Card',
      image: CDN + 'Note_Card.webp?v=1789183954',
      retail: 500
    },
    {
      id: 54466091811129,
      title: 'Ring Box',
      image: CDN + 'Gift_Box.webp?v=1789183954',
      retail: 1000
    }
  ];

  const PROTECTION = 54468315382073;
  const PREF = '_wtm_protection';
  const managed = new Set([...gifts.map(gift => gift.id), PROTECTION]);
  const downstreamFetch = window.fetch.bind(window);
  const internalRequest = Symbol('wtm.internalCartRequest');
  const maintenanceFetch = window.WTMCartTransport?.maintenanceFetch || downstreamFetch;
  const customerAddition = window.WTMCartTransport?.customerAddition || Symbol('wtm.customerAddition');

  const esc = value => String(value ?? '').replace(
    /[&<>"']/g,
    character => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[character])
  );

  const vid = item => Number(item.variant_id || item.id);

  const tier = item => Math.max(
    1,
    (rings.get(Number(item.product_id))?.variants.indexOf(vid(item)) ?? -1) + 1
  );

  const ringCount = value => value.items.reduce(
    (total, item) => total + (
      rings.has(Number(item.product_id))
        ? tier(item) * item.quantity
        : singleRingProducts.has(Number(item.product_id))
          ? birthstoneSize(item) * item.quantity
          : 0
    ),
    0
  );

  const visibleItems = value => value.items.filter(
    item => !managed.has(vid(item))
  );

  const same = (a, b) => (
    vid(a) === vid(b) &&
    JSON.stringify(Object.entries(a.properties || {}).sort()) ===
      JSON.stringify(Object.entries(b.properties || {}).sort()) &&
    (a.selling_plan_allocation?.selling_plan?.id || null) ===
      (b.selling_plan_allocation?.selling_plan?.id || null)
  );

  const trash = `
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M4 6h16M9 6V3h6v3M6 6l1 15h10l1-15M10 10v7m4-7v7"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `;

  let el;
  let cart;
  let catalog = new Map();
  let pending = 0;
  let chain = Promise.resolve();
  let refreshTimer;
  let lastRead = 0;
  let lastMutation = 0;
  let error = '';
  let openState = false;
  let returnFocus;
  let observer;
  let scrollEvents;
  let scrollLock;
  let checkingOut = false;
  let navigating = false;
  let checkoutAttempt = 0;
  let checkoutTimer;
  let interruptedReplacement = null;
  let needsRecovery = false;
  let market = { country: 'US', currency: 'USD', shopCurrency: 'USD' };
  const formatters = new Map();
  let focusAfterUpdate;

  const $ = selector => el?.querySelector(selector);
  const markupCache = new WeakMap();

  function currencyCode() {
    const value = String(cart?.currency?.iso_code || cart?.currency || market.currency || 'USD').toUpperCase();
    return /^[A-Z]{3}$/.test(value) ? value : 'USD';
  }

  function currencyFormatter(currency) {
    const language = document.documentElement.lang || 'en-US';
    const key = language + ':' + currency;
    if (!formatters.has(key)) {
      const options = { style: 'currency', currency, currencyDisplay: 'narrowSymbol' };
      try { formatters.set(key, new Intl.NumberFormat(language, options)); }
      catch (_) { formatters.set(key, new Intl.NumberFormat('en-US', options)); }
    }
    return formatters.get(key);
  }

  function formatAmount(cents, currency, explicit = false) {
    const amount = Number(cents);
    if (!Number.isFinite(amount)) return 'Unavailable';
    return currencyFormatter(currency).format(amount / 100) +
      ((currency !== 'USD' && currency !== 'GBP') || explicit ? ' ' + currency : '');
  }

  // Cart and catalog amounts already use Shopify's presentment currency.
  // Convert only the USD offer constants, never confirmed cart line prices.
  function money(cents) { return formatAmount(cents, currencyCode()); }
  function savingsMoney(cents) {
    const currency = currencyCode();
    const base = currencyFormatter(currency).resolvedOptions();
    const formatter = new Intl.NumberFormat(base.locale, {
      style:'currency', currency, currencyDisplay:base.currencyDisplay,
      minimumFractionDigits:cents % 100 === 0 ? 0 : base.maximumFractionDigits,
      maximumFractionDigits:base.maximumFractionDigits
    });
    return formatter.format(cents / 100) + (currency === 'USD' || currency === 'GBP' ? '' : ' ' + currency);
  }
  function roundMoney(cents) {
    const unit = currencyFormatter(currencyCode()).resolvedOptions().maximumFractionDigits === 0 ? 100 : 1;
    return Math.round(cents / unit) * unit;
  }
  function convertUSD(cents) {
    const currency = currencyCode();
    if (currency === 'USD') return Math.round(cents);
    const fx = window.Shopify?.currency;
    const rate = Number(fx?.rate);
    if (market.shopCurrency !== 'USD' || String(fx?.active || '').toUpperCase() !== currency ||
        !Number.isFinite(rate) || rate <= 0) return null;
    return roundMoney(cents * rate);
  }
  function localVariant(id) {
    return market.currency === currencyCode() ? variantInfo(id) : null;
  }
  function offerQuote(ring, index = 0) {
    const converted = convertUSD(ring.retail[index]);
    const discount = convertUSD(ring.retail[index] - ring.offers[index]);
    if (converted === null || discount === null) return null;
    if (currencyCode() === 'USD') return { price: ring.offers[index], original: ring.retail[index] };
    const native = localVariant(ring.variants[index]);
    const original = native?.price > 0 ? native.price : converted;
    return { price: roundMoney(Math.max(0, original - discount)), original };
  }
  function shippingEstimate(count) {
    if (count >= 1 || cart?.requires_shipping === false) return 0;
    return null;
  }
  function html(selector, value) {
    const node = $(selector);

    if (node && markupCache.get(node) !== value) {
      node.innerHTML = value;
      markupCache.set(node, value);
    }
  }

  function image(url, title, size) {
    try {
      const parsed = new URL(url, location.origin);

      if (!['https:', 'http:'].includes(parsed.protocol)) return '';

      if (parsed.hostname.includes('shopify.com')) {
        parsed.searchParams.set('width', String(size * 2));
      }

      return `
        <img
          src="${esc(parsed.href)}"
          alt="${esc(title)}"
          width="${size}"
          height="${size}"
          loading="lazy"
          decoding="async"
        >
      `;
    } catch (_) {
      return '';
    }
  }

  function productURL(url) {
    try {
      const parsed = new URL(url, location.origin);

      return parsed.origin === location.origin
        ? esc(parsed.pathname + parsed.search)
        : '#';
    } catch (_) {
      return '#';
    }
  }

  function variantInfo(id) {
    for (const product of catalog.values()) {
      const variant = product.variants.find(
        variant => Number(variant.id) === Number(id)
      );

      if (variant) return variant;
    }
  }

  function retail(item) {
    const ring = rings.get(Number(item.product_id));

    const displayComparisons = ring?.id === 10335022252345
      ? [7999, 15999, 23999] : [6999, 13999, 20999];
    const displayComparison = ring && displayComparisons[tier(item) - 1];
    const compare = displayComparison
      ? convertUSD(displayComparison)
      : localVariant(vid(item))?.compare ||
        (ring ? convertUSD(ring.retail[tier(item) - 1]) : 0) || 0;

    return Math.max(
      Number(item.original_line_price || 0),
      Number(compare || 0) * item.quantity
    );
  }

  // Reconcile the displayed amounts against the same Shopify snapshot.
  // final_line_price already contains line discounts. Cart-level discounts
  // are the remaining difference; shipping is never part of these amounts.
  function pricingSummary(value) {
    let valid = true;
    const cents = amount => {
      if (typeof amount !== 'number' || !Number.isSafeInteger(amount) || amount < 0) {
        valid = false;
        return 0;
      }
      return amount;
    };
    let lineSubtotal = 0;
    let protection = 0;
    for (const item of value.items) {
      const price = cents(item.final_line_price);
      lineSubtotal += price;
      if (vid(item) === PROTECTION) protection += price;
    }
    const reported = cents(value.total_price);
    if (typeof value.items_subtotal_price !== 'undefined' &&
        cents(value.items_subtotal_price) !== lineSubtotal) valid = false;
    if (!Number.isSafeInteger(lineSubtotal) || reported > lineSubtotal) valid = false;

    const discount = Math.max(0, lineSubtotal - reported);
    const applications = value.cart_level_discount_applications;
    if (Array.isArray(applications) && applications.length) {
      const allocated = applications.reduce((total, application) => (
        total + (application.target_type === 'shipping_line'
          ? 0 : cents(application.total_allocated_amount))
      ), 0);
      if (allocated !== discount) valid = false;
    }
    return {
      subtotal: lineSubtotal - protection,
      protection,
      discount,
      merchandiseTotal: lineSubtotal - discount,
      valid
    };
  }

  async function verifyPricing() {
    if (pricingSummary(cart).valid) return;
    // One confirmation read, not a timer, retry loop, or synthetic correction.
    await read(false);
    if (!pricingSummary(cart).valid) {
      throw new Error('Your item prices and cart total do not match yet. Please retry before checking out.');
    }
  }

  function birthstoneOptionKey(value) {
    return String(value || '').replace(/[\s_-]/g, '').toLowerCase();
  }

  function birthstoneMonth(value) {
    if (typeof value !== 'string') return null;
    const match = value.trim().match(/^([a-z]+)(?:\s*\([^)]*\))?$/i);
    return match ? birthstonePreview.months.find(month =>
      month.toLowerCase() === match[1].toLowerCase()
    ) || null : null;
  }

  function birthstoneSize(item) {
    if (Number(item.product_id) !== birthstonePreview.productId) return 1;
    return Number(String(item.variant_title || '').match(/^Buy\s+([1-3])$/i)?.[1] || 1);
  }

  function birthstoneSelections(item) {
    if (Number(item.product_id) !== birthstonePreview.productId) return null;
    if (!/^Buy\s+[1-3]$/i.test(item.variant_title || '')) return [birthstoneSelection(item)];
    return Array.from({ length: birthstoneSize(item) }, (_, index) => {
      const values = ['First', 'Second'].map(side => item.properties?.[`Ring ${index + 1} - ${side} Birthstone`] || (index === 0 ? item.properties?.[`${side} Birthstone`] : '') || '');
      return {
        first: birthstoneMonth(values[0]), second: birthstoneMonth(values[1]),
        colors: values.map(value => value.match(/\(([^)]+)\)\s*$/)?.[1] || '')
      };
    });
  }

  function birthstoneSelection(item) {
    if (Number(item.product_id) !== birthstonePreview.productId) return null;
    const named = Array.isArray(item.options_with_values) ? item.options_with_values : [];
    const ordered = Array.isArray(item.variant_options) && item.variant_options.length === 2
      ? item.variant_options : null;
    const titleParts = typeof item.variant_title === 'string'
      ? item.variant_title.split(/\s*\/\s*/) : [];
    const title = titleParts.length === 2 && titleParts.every(birthstoneMonth)
      ? titleParts : null;
    const resolve = (name, index) => {
      const matches = named.filter(option => birthstoneOptionKey(option?.name) === name);
      if (matches.length) return matches.length === 1 ? matches[0].value : null;
      return ordered ? ordered[index] : title?.[index];
    };
    const values = [resolve('firstbirthstone', 0), resolve('secondbirthstone', 1)];
    return {
      first: birthstoneMonth(values[0]), second: birthstoneMonth(values[1]),
      colors: values.map(value => typeof value === 'string' ? value.match(/\(([^)]+)\)\s*$/)?.[1] || '' : '')
    };
  }

  function birthstoneDetailsHTML(selection) {
    const palette = ['#8d1736','#8240af','#48c2e8','#eef4fa','#168b49','#bd8ee0','#cc2545','#9dcb3b','#1d3dba','#e5a1c4','#e4b935','#636bd7'];
    return ['first', 'second'].map((side, index) => {
      const month = selection[side];
      if (!month) return '';
      const color = palette[birthstonePreview.months.indexOf(month)];
      const swatch = color ? `<span aria-hidden="true" style="display:inline-block;width:10px;height:10px;margin-right:4px;border:1px solid rgba(17,17,17,.18);border-radius:50%;background:${color};vertical-align:baseline"></span>` : '';
      const name = selection.colors?.[index];
      return `${swatch}${index === 0 ? 'First' : 'Second'} Birthstone: ${esc(month)}${name ? ' (' + esc(name) + ')' : ''}`;
    }).filter(Boolean).join('<br>');
  }

  function birthstoneImageHTML(selection, title) {
    if (!selection?.first || !selection?.second) return '';
    const first = birthstonePreview.overlays.first[selection.first.toLowerCase()];
    const second = birthstonePreview.overlays.second[selection.second.toLowerCase()];
    if (!first || !second) return '';
    const label = `${title || 'Birthstone ring'}; First Birthstone: ${selection.first}; Second Birthstone: ${selection.second}`;
    const layers = [birthstonePreview.baseImage, first, second].map(source => {
      const url = new URL(source);
      url.searchParams.set('width', '288');
      return `<img src="${esc(url.href)}" alt="" width="1254" height="1254" loading="lazy" decoding="async" style="position:absolute;inset:0;width:100%;height:100%;object-fit:contain;mix-blend-mode:normal">`;
    }).join('');
    return `<span class="wtmc-birthstone-preview" role="img" aria-label="${esc(label)}" style="display:block;position:relative;width:100%;aspect-ratio:1;align-self:center">${layers}</span>`;
  }

  function itemHTML(item) {
    const ring = rings.get(Number(item.product_id));
    const birthstones = birthstoneSelections(item);
    const number = ring ? tier(item) * item.quantity : item.quantity;
    const original = retail(item);
    const price = Number(item.final_line_price);
    const variantTitle = String(item.variant_title || '');
    const variantDetails = birthstones?.length
      ? (birthstones.length > 1 && item.quantity > 1 ? `${item.quantity} sets<br>` : '') +
        birthstones.map((selection, index) => `<span style="display:block;margin-top:6px">${birthstones.length > 1 ? `<strong>Ring ${index + 1}</strong><br>` : ''}${birthstoneDetailsHTML(selection)}</span>`).join('')
      : variantTitle === 'Default Title' || /^Buy\s+(?:[1-9]|10)$/i.test(variantTitle.trim())
        ? ''
        : esc(variantTitle);

    const properties = Object.entries(item.properties || {})
      .filter(([key, value]) => key[0] !== '_' && value && !(
        birthstones && (
          (birthstones[0]?.first && birthstoneOptionKey(key) === 'firstbirthstone') ||
          (birthstones[0]?.second && birthstoneOptionKey(key) === 'secondbirthstone') ||
          /^ring[1-3](?:first|second)birthstone$/.test(birthstoneOptionKey(key))
        )
      ))
      .map(([key, value]) => `
        <div class="wtmc-variant">
          ${esc(key)}: ${esc(value)}
        </div>
      `)
      .join('');

    return `
      <article
        class="wtmc-item"
        data-line="${esc(item.key)}"
        data-product="${item.product_id}"
      >
        <a class="wtmc-image" href="${productURL(item.url)}"${birthstones?.length > 1 ? ' style="height:auto;align-self:start;display:block"' : ''}>
          ${(birthstones && birthstones.map((selection, index) => birthstoneImageHTML(selection, item.product_title + (birthstones.length > 1 ? ` — Ring ${index + 1}` : ''))).join('')) || image(
            item.image || item.featured_image?.url || ring?.image,
            item.product_title,
            144
          )}
        </a>

        <div class="wtmc-item-info">
          <a class="wtmc-title" href="${productURL(item.url)}">
            ${esc(item.product_title || item.title)}
          </a>

          ${variantDetails ? `<p class="wtmc-variant">${variantDetails}</p>` : ''}

          ${properties}

          <div class="wtmc-item-bottom">
            <div class="wtmc-item-price">
              <div class="wtmc-prices">
                <strong>${money(price)}</strong>
                ${original > price ? `<s>${money(original)}</s>` : ''}
              </div>


            </div>

              ${birthstones ? '' : `
          <div
              class="wtmc-quantity"
              aria-label="${ring ? 'Rings' : 'Quantity'} for ${esc(item.product_title)}"
            >
              <button
                type="button"
                data-wtm-action="minus"
                data-key="${esc(item.key)}"
                aria-label="${number <= 1 ? 'Remove' : 'Decrease'} ${esc(item.product_title)}"
              >−</button>

              <span>${number}</span>

              <button
                type="button"
                data-wtm-action="plus"
                data-key="${esc(item.key)}"
                aria-label="Increase ${esc(item.product_title)}"
              >+</button>
            </div>
            `}
          </div>
        </div>

        <button
          class="wtmc-remove"
          type="button"
          data-wtm-action="remove"
          data-key="${esc(item.key)}"
          aria-label="Remove ${esc(item.product_title)}"
        >
          ${trash}
        </button>
      </article>
    `;
  }

  function render() {
    if (!el || !cart) return;

    const active = document.activeElement;

    const focus = active?.closest('wtm-cart-drawer') === el
      ? {
          action: active.dataset.wtmAction,
          key: active.dataset.key
        }
      : null;

    const items = visibleItems(cart);
    const numberOfRings = ringCount(cart);
    const shipping = shippingEstimate(numberOfRings);
    el.classList.toggle('wtmc-long-money', money(cart.total_price).length > 13);

    const protectionItems = cart.items.filter(
      item => vid(item) === PROTECTION
    );

    const pricing = pricingSummary(cart);
    const protectionCost = pricing.protection;

    el.classList.toggle('is-empty', items.length === 0);

    $('[data-wtm-count]').textContent = numberOfRings
      ? `· ${numberOfRings} ${numberOfRings === 1 ? 'ring' : 'rings'}`
      : items.length
        ? `· ${items.reduce((total, item) => total + item.quantity, 0)} items`
        : '';

    html(
      '[data-wtm-items]',
      items.length
        ? items.map(itemHTML).join('')
        : '<div class="wtmc-empty"><p>Your cart is empty</p></div>'
    );

    $('[data-wtm-shipping]').hidden = !numberOfRings;

    html(
      '[data-wtm-shipping]',
      `<p><svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M3 8.5 6.5 12 13 4.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg><strong>FREE Shipping Until the Sale Ends</strong></p><div class="wtmc-track" aria-hidden="true"><span></span></div>`
    );

    syncSale();
    $('[data-wtm-gifts]').hidden = !numberOfRings;

    html(
      '[data-wtm-gifts]',
      '<h3 class="wtmc-label">Included with your order</h3>' +
      [gifts[2], gifts[1], gifts[0]].map(gift => {
        const lines = cart.items.filter(
          item => vid(item) === gift.id
        );

        const quantity = lines.reduce(
          (total, item) => total + item.quantity,
          0
        );

        const cost = lines.reduce(
          (total, item) => total + item.final_line_price,
          0
        );

        const label = gift.digital ? gift.title : gift.id === 54466091811129
          ? (quantity > 1 ? 'Gift Boxes' : 'Gift Box') : (quantity > 1 ? 'Message Cards' : 'Message Card');
        const reference = lines.reduce((total, item) => total + Number(item.original_line_price), 0);
        return `<div class="wtmc-gift">
          <div class="wtmc-gift-picture">${image(gift.image, label, 64)}
            ${!gift.digital && quantity > 1 ? `<span class="wtmc-gift-quantity">x${quantity}</span>` : ''}
          </div>
          <div class="wtmc-gift-copy">
            ${quantity ? `<s>${money(reference)}</s>` : ''}
            <div class="wtmc-prices">${quantity && cost === 0 ? '<span class="wtmc-free">FREE</span>' : quantity ? money(cost) : '<span>Updating…</span>'}</div>
            <strong>${esc(label)}</strong>
          </div>
        </div>`;
      }).join('')
    );

    const primary = items.find(item => rings.has(Number(item.product_id)));
    const primaryRing = primary ? rings.get(Number(primary.product_id)) : null;
    const byHandle = new Map([...rings.values()].map(ring => [
      (catalog.get(ring.id)?.url || '').split('/').pop().split('?')[0], ring
    ]));
    const primaryHandle = primaryRing
      ? (catalog.get(primaryRing.id)?.url || '').split('/').pop().split('?')[0] : '';
    const relatedHandles = {
      'love-dad-hug-ring': ['love-mom-hug-ring', 'i-love-you-forever-hug-ring', 'always-with-you-hug-ring'],
      'love-mom-hug-ring': ['love-dad-hug-ring', 'i-love-you-forever-hug-ring', 'always-with-you-hug-ring'],
      'i-love-you-forever-hug-ring': ['always-with-you-hug-ring', 'unbreakable-bond-ring', 'i-f-cking-need-you-ring'],
      'always-with-you-hug-ring': ['love-dad-hug-ring', 'love-mom-hug-ring', 'i-love-you-forever-hug-ring']
    }[primaryHandle] || [];
    const order = primaryRing ? [...pairings[primaryRing.index], primaryRing.index]
      : rows.map((_, index) => index);
    const owned = new Set(items.map(item => Number(item.product_id)));
    const hasBirthstone = items.some(
      item => Number(item.product_id) === birthstonePreview.productId
    );
    const birthstoneUpsellHandles = [
      'i-love-you-forever-hug-ring',
      'always-with-you-hug-ring',
      'love-mom-hug-ring',
      'love-dad-hug-ring',
      'strength-within-ring',
      'faith-over-fear-ring',
      'forever-with-me-paw-ring'
    ];
    const excludedUpsellHandles = new Set([
      'i-f-cking-need-you-ring',
      'unbreakable-bond-ring'
    ]);
    const ordered = [
      ...(hasBirthstone ? birthstoneUpsellHandles : relatedHandles)
        .map(handle => byHandle.get(handle)),
      ...order.map(index => rings.get(rows[index][0])),
      ...rings.values()
    ].filter(Boolean);
    const candidates = [...new Map(ordered.map(ring => [ring.id, ring])).values()]
      .filter(ring =>
        !owned.has(ring.id) &&
        ring.id !== birthstonePreview.productId &&
        !excludedUpsellHandles.has(
          (catalog.get(ring.id)?.url || '').split('/').pop().split('?')[0]
        ) &&
        variantInfo(ring.variants[0])?.available === true
      );
    const upsellReasons = {
      'love-mom-hug-ring': primaryHandle === 'love-dad-hug-ring'
        ? 'Add a hug from Mom, too.' : 'A hug from Mom, wherever she goes.',
      'love-dad-hug-ring': primaryHandle === 'love-mom-hug-ring'
        ? 'Add a hug from Dad, too.' : 'A hug from Dad, wherever she goes.',
      'i-love-you-forever-hug-ring': 'Another way to say “I love you.”',
      'always-with-you-hug-ring': primaryHandle === 'forever-with-me-paw-ring'
        ? 'A little comfort to keep close.' : 'A hug they can carry with them.',
      'faith-over-fear-ring': primaryHandle === 'strength-within-ring'
        ? 'A little faith to go with their strength.' : 'Keep a little faith close.',
      'strength-within-ring': 'A reminder of the strength within.',
      'unbreakable-bond-ring': 'Another reminder of your bond.',
      'i-f-cking-need-you-ring': 'Say how much they mean to you.',
      'forever-with-me-paw-ring': 'Keep their pawprints close.'
    };
    const upsellReason = candidate => upsellReasons[
      (catalog.get(candidate?.id)?.url || '').split('/').pop().split('?')[0]
    ] || 'A little meaning to go with your ring.';
    const upsellHeading = upsellReason(candidates[0]);

    $('[data-wtm-upsell]').hidden = !numberOfRings || !candidates.length;
    const rail = $('[data-wtm-upsell] .wtmc-upsell-rail');
    const railPosition = rail?.scrollLeft || 0;
    html('[data-wtm-upsell]', `
      <div class="wtmc-upsell-heading"><h3 class="wtmc-label">${esc(upsellHeading)}</h3>
        <div class="wtmc-slider-controls" ${candidates.length < 2 ? 'hidden' : ''}><button type="button" data-wtm-slide="-1" aria-label="Previous ring"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="m14.5 6.5-5.5 5.5 5.5 5.5" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg></button><button type="button" data-wtm-slide="1" aria-label="Next ring"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="m9.5 6.5 5.5 5.5-5.5 5.5" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg></button></div>
      </div>
      <div class="wtmc-upsell-rail" tabindex="0" role="region" aria-label="Explore other rings">${candidates.map(candidate => {
        const product = catalog.get(candidate.id);
        const quote = offerQuote(candidate);
        const disabled = variantInfo(candidate.variants[0])?.available === false || !quote;
        return `<div class="wtmc-upsell" data-wtm-upsell-reason="${esc(upsellReason(candidate))}">
          ${image(product?.image || candidate.image, candidate.title, 64)}
          <div><p class="wtmc-title">${esc(product?.title || candidate.title)}</p>
            <div class="wtmc-prices"><strong>${quote ? money(quote.price) : 'Unavailable'}</strong>${quote && quote.original > quote.price ? `<s>${money(quote.original)}</s>` : ''}</div>
          </div>
          <button type="button" data-wtm-action="upsell" data-variant="${candidate.variants[0]}" aria-label="Add one ${esc(candidate.title)}" ${disabled ? 'disabled' : ''}>Add +</button>
        </div>`;
      }).join('')}</div>`);
    if ($('[data-wtm-upsell] .wtmc-upsell-rail')) $('[data-wtm-upsell] .wtmc-upsell-rail').scrollLeft = railPosition;

    const protectionVariant = localVariant(PROTECTION);
    const protectionAmount = protectionItems.length ? protectionCost
      : protectionVariant ? Number(protectionVariant.price) : null;
    const protectionAvailable = protectionItems.length > 0 || (
      protectionVariant?.available !== false &&
      protectionAmount !== null && Number.isFinite(protectionAmount) && protectionAmount >= 0
    );
    const protectionPrice = protectionAvailable ? money(protectionAmount) : '';

    const totalSavings = Math.max(0, Number(cart.total_discount || 0));
    const estimatedTotal = pricing.merchandiseTotal + (shipping ?? 0);
    // Compare like-for-like totals, including any selected insurance in both.
    const comparisonTotal = estimatedTotal + totalSavings;
    const savingsLabel = `SAVE ${savingsMoney(totalSavings)}`;

    $('[data-wtm-protection]').hidden = !numberOfRings || !protectionAvailable;
    html('[data-wtm-protection]', numberOfRings && protectionAvailable ? `<div class="wtmc-protection-row">
      <img class="wtmc-protection-image" src="https://cdn.shopify.com/s/files/1/0919/5264/4409/files/Chrome_Heart_Knot_Shield_Emblem.webp?v=1791773133&amp;width=120" alt="" width="44" height="44" decoding="async">
      <div class="wtmc-protection-copy"><p>Premium Shipping Insurance</p><small>Our standard shipping is free, but with this option your order will be insured against: damage, loss, or theft.</small></div>
      <div class="wtmc-protection-choice"><div class="wtmc-protection-price">${protectionPrice}</div>
        <label class="wtmc-switch"><input type="checkbox" data-wtm-action="protection" aria-label="Add optional Premium Shipping Insurance, ${esc(protectionPrice)} per order" ${protectionItems.length ? 'checked' : ''}><span class="wtmc-switch-track" aria-hidden="true"></span></label>
      </div>
    </div>` : '');

    html(
      '[data-wtm-checkout-total]',
      items.length ? `<div class="wtmc-checkout-total">
        <div class="wtmc-total-line">
          <span class="wtmc-checkout-total-label">${shipping === null ? 'Items total' : 'Estimated total'}</span>
          <div class="wtmc-checkout-amount">
            ${totalSavings > 0 ? `<s class="wtmc-checkout-compare" data-wtm-compare-total-cents="${comparisonTotal}">${money(comparisonTotal)}</s>` : ''}
            <b data-wtm-sticky-total-cents="${estimatedTotal}">${money(estimatedTotal)}</b>
            ${totalSavings > 0 ? `<span class="wtmc-checkout-saving" data-wtm-savings-cents="${totalSavings}" data-wtm-savings-type="amount">${esc(savingsLabel)}</span>` : ''}
          </div>
        </div>
      </div>` : ''
    );

    // A failed request can leave the checkbox's live property changed even
    // when cached insurance HTML is identical. Restore Shopify's confirmed state.
    const protectionToggle = $('[data-wtm-action="protection"]');
    if (protectionToggle) protectionToggle.checked = protectionItems.length > 0;

    $('[data-wtm-checkout-form]').hidden = !items.length;

    showError();
    setControls();

    if (focus?.action && !active.isConnected) {
      Array.from(el.querySelectorAll('[data-wtm-action]'))
        .find(button => (
          button.dataset.wtmAction === focus.action &&
          button.dataset.key === focus.key &&
          !button.disabled
        ))
        ?.focus({ preventScroll: true });
    }
  }

  function showError() {
    const node = $('[data-wtm-error]');
    if (!node) return;

    node.hidden = !error;

    html(
      '[data-wtm-error]',
      error
        ? `
          ${esc(error)}<br>
          <button type="button" data-wtm-action="retry">
            Retry cart update
          </button>
        `
        : ''
    );
  }

  function setControls() {
    if (!el) return;

    for (const button of el.querySelectorAll(
      '[data-wtm-action]:not([data-wtm-action="close"])'
    )) {
      if (!button.hasAttribute('data-rule-disabled')) {
        button.dataset.ruleDisabled = String(button.disabled);
      }

      button.disabled =
        pending > 0 || checkingOut ||
        button.dataset.ruleDisabled === 'true';
    }

    const checkout = $('[data-wtm-checkout]');

    if (!checkout) return;

    checkout.disabled =
      pending > 0 || checkingOut ||
      needsRecovery ||
      (cart && !pricingSummary(cart).valid) ||
      !visibleItems(cart || { items: [] }).length;

    const checkoutLabel = checkout.querySelector('[data-wtm-checkout-label]') || checkout;
    checkoutLabel.textContent = navigating
      ? 'OPENING SECURE CHECKOUT…'
      : checkingOut
        ? 'CHECKING YOUR CART…'
        : pending
        ? 'UPDATING CART…'
        : 'Checkout Securely';

    if (!pending && !checkingOut && focusAfterUpdate) {
      const focus = focusAfterUpdate;
      focusAfterUpdate = null;

      const target = Array.from(
        el.querySelectorAll('[data-wtm-action]')
      ).find(button => (
        button.dataset.wtmAction === focus.action &&
        (focus.key ? button.dataset.key === focus.key : true) &&
        !button.disabled
      ));

      const fallback = focus.product
        ? $(
            `[data-product="${focus.product}"] button[data-wtm-action="${focus.action}"]:not(:disabled)`
          ) || $(
            `[data-product="${focus.product}"] .wtmc-quantity button:not(:disabled)`
          )
        : null;

      if (openState) {
        (target || fallback || $('.wtmc-close'))
          ?.focus({ preventScroll: true });
      }
    }

    $('[data-wtm-scroll]').setAttribute(
      'aria-busy',
      String(pending > 0 || checkingOut)
    );
    checkout.setAttribute('aria-busy', String(pending > 0 || checkingOut));
  }

  function adopt(value, paint = true) {
    if (
      !Array.isArray(value?.items) ||
      typeof value.total_price !== 'number'
    ) {
      throw new Error('We could not read your cart. Please retry.');
    }

    cart = value;
    lastRead = Date.now();

    if (paint) render();
  }

  // Bound both the response and its JSON body. Never retry a POST automatically:
  // a lost response can still mean Shopify saved the change.
  async function cartTransport(input, options = {}, consume = response => response, transport) {
    const controller = new AbortController();
    const callerSignal = options.signal || (
      input instanceof Request ? input.signal : null
    );
    const abort = () => controller.abort(callerSignal?.reason);
    let timer;

    if (callerSignal?.aborted) {
      throw callerSignal.reason || new DOMException('Request cancelled.', 'AbortError');
    }

    callerSignal?.addEventListener('abort', abort, { once: true });

    try {
      return await Promise.race([
        (async () => {
          const requestOptions = { ...options, signal: controller.signal, [internalRequest]: true };
          const response = await (transport || window.fetch).call(window, input, requestOptions);
          return await consume(response);
        })(),
        new Promise((_, reject) => {
          timer = setTimeout(() => {
            const exception = new Error('The cart request timed out. Please retry.');
            exception.name = 'TimeoutError';
            reject(exception);
            controller.abort(exception);
          }, 12000);
        })
      ]);
    } finally {
      clearTimeout(timer);
      callerSignal?.removeEventListener('abort', abort);
    }
  }

  async function request(path, body) {
    return cartTransport(ROOT + path, {
      [customerAddition]: Boolean(body && path === 'cart/add.js'),
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
        ...(body ? { 'Content-Type': 'application/json' } : {})
      },
      ...(body ? { body: JSON.stringify(body) } : {})
    }, async response => {
      const value = await response.json().catch(() => null);

      if (!response.ok) {
        throw new Error(
          typeof value?.description === 'string'
            ? value.description
            : 'Your cart could not be updated. Please retry.'
        );
      }

      if (!value || typeof value !== 'object') {
        throw new Error('We could not read the cart response. Please retry.');
      }
      return value;
    }, body && path !== 'cart/add.js' ? maintenanceFetch : undefined);
  }

  function cartFromAddition(value, transaction) {
    try {
      const markup = value?.sections?.['wtm-cart-state'];
      if (typeof markup !== 'string') return null;
      const template = document.createElement('template');
      template.innerHTML = markup;
      const state = JSON.parse(template.content.querySelector('[data-wtm-confirmed-cart]')?.textContent || 'null');
      if (!Array.isArray(state?.items) || typeof state.currency !== 'string' ||
          state.currency !== cart.currency || !Number.isSafeInteger(state.total_price) ||
          !Number.isSafeInteger(state.item_count) || !state.attributes ||
          !Array.isArray(state.cart_level_discount_applications) ||
          !state.items.every(item => typeof item.key === 'string' && item.key &&
            Number.isSafeInteger(item.quantity) && item.quantity > 0 &&
            Number.isSafeInteger(item.variant_id) && Number.isSafeInteger(item.product_id)) ||
          state.items.reduce((sum, item) => sum + item.quantity, 0) !== state.item_count ||
          !pricingSummary(state).valid) return null;
      const added = state.items.filter(item => item.properties?._wtm_offer_tx === transaction.token);
      if (added.length !== transaction.additions.length || !transaction.additions.every(item =>
        added.some(line => vid(line) === item.id && line.quantity === item.quantity))) return null;
      return state;
    } catch (_) {
      return null;
    }
  }

  async function read(paint = true) {
    const value = await request('cart.js');
    adopt(value, paint);
    return value;
  }

  // Cart mutations run in order.
  function enqueue(task) {
    pending++;
    setControls();

    const job = chain.then(task);
    chain = job.catch(() => {});

    return job.finally(() => {
      pending--;
      setControls();
    });
  }

  function desired(value, count = ringCount(value)) {

    const wantsProtection =
      count > 0 &&
      value.attributes?.[PREF] === 'on';

    return new Map([
      [gifts[0].id, count ? 1 : 0],
      [gifts[1].id, count],
      [gifts[2].id, count],
      [PROTECTION, wantsProtection ? 1 : 0]
    ]);
  }

  // Gifts are identified by their variant IDs. No extra property writes are
  // needed to mark each free item; existing customer/line properties stay intact.
  function managedUpdates(value, count = ringCount(value)) {
    const updates = {};
    for (const [id, quantity] of desired(value, count)) {
      const lines = value.items.filter(item => vid(item) === id);
      lines.forEach((line, index) => {
        const required = index === 0 ? quantity : 0;
        if (line.quantity !== required) updates[line.key] = required;
      });
      if (!lines.length && quantity) updates[id] = quantity;
    }
    return updates;
  }

  function bundledUpdates(productId, plan) {
    const ring = rings.get(Number(productId));
    const next = plan.reduce((sum, item) => (
      sum + (ring.variants.indexOf(item.id) + 1) * item.quantity
    ), 0);
    const count = ringCount(cart) - productRingCount(productId) + next;
    return { ...managedUpdates(cart, count), ...planUpdates(productId, plan) };
  }

  async function reconcile() {
    const updates = managedUpdates(cart);
    const reset = ringCount(cart) === 0 && cart.attributes?.[PREF];
    if (Object.keys(updates).length || reset) {
      adopt(await request('cart/update.js', {
        updates,
        ...(reset ? { attributes: { [PREF]: '' } } : {})
      }), false);
    }

    for (const [id, requiredQuantity] of desired(cart)) {
      const actualQuantity = cart.items
        .filter(item => vid(item) === id)
        .reduce((total, item) => total + item.quantity, 0);

      if (actualQuantity !== requiredQuantity) {
        throw new Error(
          'Your included items did not finish updating. Please retry.'
        );
      }
    }

    await verifyPricing();
    for (const item of cart.items) {
      const ring = rings.get(Number(item.product_id));
      const nativeCap = ring ? ring.offers[tier(item)-1] * item.quantity : 0;
      const bulk = ring && productRingCount(ring.id) > 10;
      const allowed = bulk
        ? Math.max(nativeCap, Math.round(tier(item) * item.quantity * ring.offers[9] / 10)) + 1
        : nativeCap;
      if (ring && currencyCode() === 'USD' && item.final_line_price > allowed) {
        throw new Error('Your bundle discount has not applied. Please retry before checking out.');
      }
    }

    if (cart.items.some(item => (
      gifts.some(gift => gift.id === vid(item)) &&
      item.final_line_price > 0
    ))) {
      throw new Error(
        'Your free-gift discount has not applied. Please retry before checking out.'
      );
    }
  }

  async function recover(exception) {
    error = exception?.message || 'Your cart could not be updated. Please retry.';
    needsRecovery = !exception?.cartUnchanged;
    showError();

    try {
      await read(false);
      await settleReplacement();
      render();
    } catch (_) {
      // Keep the last confirmed cart and the visible error. Retry re-reads it.
    }
    showError();
  }

  function action(task, fresh = false, prepare) {
    return enqueue(async () => {
      error = '';
      showError();

      try {
        const prepared = prepare?.();
        if (needsRecovery || fresh) await read(false);
        await settleReplacement();
        if (prepared) await prepared;

        await task();
        await reconcile();

        needsRecovery = false;
        render();

        $('[data-wtm-status]').textContent = 'Cart updated.';
        return true;
      } catch (exception) {
        await recover(exception);
        return false;
      }
    });
  }

  function refresh(force = false) {
    clearTimeout(refreshTimer);
    if (checkingOut) return;

    refreshTimer = setTimeout(() => {
      if (checkingOut || (!force && Date.now() - lastRead < 600)) return;
      action(async () => {}, true);
    }, 70);
  }

  function productLines(id) { return cart.items.filter(item => Number(item.product_id) === Number(id)); }
  function productRingCount(id) { return productLines(id).reduce((sum, item) => sum + tier(item) * item.quantity, 0); }
  function cleanProperties(item) {
    return Object.fromEntries(Object.entries(item?.properties || {}).filter(([key]) => key !== '_wtm_offer_tx').sort(([a],[b]) => a.localeCompare(b)));
  }
  function unchangedError(message) { const exception = new Error(message); exception.cartUnchanged = true; return exception; }
  function bundleItems(ring, target) {
    const items = [];
    const tens = Math.floor(target / 10);
    const remainder = target % 10;
    if (tens) items.push({ id: ring.variants[9], quantity: tens });
    if (remainder) items.push({ id: ring.variants[remainder - 1], quantity: 1 });
    return items;
  }

  function assertTarget(ring, target, sources) {
    if (!ring || !Number.isSafeInteger(target) || target < 1) {
      throw unchangedError('Choose a valid number of rings.');
    }
    if (sources.some(item => !ring.variants.includes(vid(item)) || item.selling_plan_allocation)) {
      throw unchangedError('This ring has another option or purchase plan in your cart. Review that item before adding a bundle.');
    }
    if (new Set(sources.map(item => JSON.stringify(cleanProperties(item)))).size > 1) {
      throw unchangedError('These rings have different personalized details. Keep them separate and adjust each item in your cart.');
    }
    if (bundleItems(ring, target).some(item => variantInfo(item.id)?.available === false)) {
      throw unchangedError('This bundle is currently unavailable. Your existing rings are still in your cart.');
    }
  }

  let cartInstrumentation;
  function waitForCartInstrumentation() {
    if (cartInstrumentation) return cartInstrumentation;
    const script = document.querySelector('script[src*="/shop_events_listener-"]');
    if (!script || performance.getEntriesByName(script.src).some(entry => entry.responseEnd > 0)) {
      return Promise.resolve();
    }
    cartInstrumentation = new Promise(resolve => {
      const finish = () => {
        clearTimeout(timer);
        script.removeEventListener('load', finish);
        script.removeEventListener('error', finish);
        resolve();
      };
      const timer = setTimeout(finish, 2000);
      script.addEventListener('load', finish, { once: true });
      script.addEventListener('error', finish, { once: true });
    });
    return cartInstrumentation;
  }

  function transactionToken() {
    return typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID() : Array.from(crypto.getRandomValues(new Uint32Array(4))).join('-');
  }

  function matchesPlan(productId, plan) {
    const lines = productLines(productId);
    return lines.length === plan.length && plan.every(item =>
      lines.some(line => vid(line) === item.id && line.quantity === item.quantity));
  }

  function matchesSources(productId, sources) {
    const lines = productLines(productId);
    return lines.length === sources.length && sources.every(source =>
      lines.some(line => same(line, source) && line.quantity === source.quantity));
  }

  function planUpdates(productId, plan) {
    const lines = productLines(productId);
    const updates = Object.fromEntries(lines.map(line => [line.key, 0]));
    for (const item of plan) {
      const existing = lines.find(line => vid(line) === item.id);
      updates[existing ? existing.key : item.id] = item.quantity;
    }
    return updates;
  }

  async function finishReplacement(transaction) {
    const { productId, plan, properties } = transaction;
    if (!matchesPlan(productId, plan)) throw new Error('Your bundle did not finish updating. Please retry.');
    for (const item of plan) {
      const line = productLines(productId).find(line => vid(line) === item.id);
      // A normalization token is not needed after the confirmed replacement.
      // Only write again when personalized properties actually need restoring.
      if (JSON.stringify(cleanProperties(line)) ===
          JSON.stringify(cleanProperties({ properties }))) continue;
      adopt(await request('cart/change.js', {
        id: line.key, quantity: item.quantity, properties
      }), false);
    }
    if (!matchesPlan(productId, plan) || productLines(productId).some(line =>
      JSON.stringify(cleanProperties(line)) !== JSON.stringify(cleanProperties({ properties })))) {
      throw new Error('Your bundle did not finish updating. Please retry.');
    }
    interruptedReplacement = null;
  }

  async function restoreReplacement(transaction) {
    const { productId, sources, plan, properties } = transaction;
    const knownIds = new Set([...sources.map(vid), ...(transaction.inputSources || []).map(vid), ...plan.map(item => item.id)]);
    const expectedProperties = JSON.stringify(cleanProperties({ properties }));
    if (productLines(productId).some(line => !knownIds.has(vid(line)) ||
      (Object.keys(cleanProperties(line)).length && JSON.stringify(cleanProperties(line)) !== expectedProperties))) {
      throw new Error('Your cart changed elsewhere during this bundle update. Please review your cart before checking out.');
    }
    const restored = [];
    for (const source of sources) {
      const existing = restored.find(item => item.id === vid(source));
      if (existing) existing.quantity += source.quantity;
      else restored.push({ id: vid(source), quantity: source.quantity });
    }
    adopt(await request('cart/update.js', { updates: bundledUpdates(productId, restored) }), false);
    for (const item of restored) {
      const line = productLines(productId).find(line => vid(line) === item.id);
      if (!line) throw new Error('The interrupted bundle change could not be reversed. Please retry.');
      const source = sources.find(source => vid(source) === item.id);
      adopt(await request('cart/change.js', {
        id: line.key, quantity: item.quantity,
        properties: { ...cleanProperties(source), _wtm_offer_tx: transactionToken() }
      }), false);
    }
    if (!matchesPlan(productId, restored)) throw new Error('The interrupted bundle change could not be reversed. Please retry.');
    interruptedReplacement = null;
  }

  async function settleReplacement() {
    const transaction = interruptedReplacement;
    if (!transaction) return;
    if (transaction.kind === 'addition') {
      const lines = productLines(transaction.productId);
      const added = lines.filter(line => line.properties?._wtm_offer_tx === transaction.token);
      const accepted = added.length === transaction.additions.length && transaction.additions.every(item =>
        added.some(line => vid(line) === item.id && line.quantity === item.quantity));
      const others = lines.filter(line => line.properties?._wtm_offer_tx !== transaction.token);
      const intact = others.length === transaction.sources.length && transaction.sources.every(source =>
        others.some(line => same(line, source) && line.quantity === source.quantity));
      if (!intact) throw new Error('Your cart changed elsewhere during this bundle update. Please review your cart before checking out.');
      if (accepted) {
        await replaceProduct(rings.get(transaction.productId), lines, transaction.target, transaction.sources);
        transaction.completed = true;
      } else {
        if (added.length) adopt(await request('cart/update.js', {
          updates: Object.fromEntries(added.map(line => [line.key, 0]))
        }), false);
        interruptedReplacement = null;
      }
      return;
    }
    if (matchesSources(transaction.productId, transaction.sources)) {
      interruptedReplacement = null;
      return;
    }
    if (matchesPlan(transaction.productId, transaction.plan)) {
      try {
        await finishReplacement(transaction);
        transaction.completed = true;
        return;
      } catch (exception) {
        await read(false);
        await restoreReplacement(transaction);
        throw exception;
      }
    }
    await restoreReplacement(transaction);
  }

  async function replaceProduct(ring, sources, target, rollbackSources = sources) {
    assertTarget(ring, target, sources);
    const plan = bundleItems(ring, target);
    if (matchesPlan(ring.id, plan)) {
      interruptedReplacement = null;
      return;
    }
    const transaction = {
      kind: 'normalization', productId: ring.id, sources: structuredClone(rollbackSources), inputSources: structuredClone(sources), plan,
      properties: { ...cleanProperties(sources[0]), _wtm_offer_tx: transactionToken() }
    };
    interruptedReplacement = transaction;
    try {
      adopt(await request('cart/update.js', { updates: bundledUpdates(ring.id, plan) }), false);
      await finishReplacement(transaction);
      transaction.completed = true;
    } catch (exception) {
      await read(false);
      await settleReplacement();
      if (!transaction.completed) throw exception;
    }
  }

  async function addRings(ring, amount) {
    if (!Number.isSafeInteger(amount) || amount < 1) throw unchangedError('Choose a valid number of rings.');
    await waitForCartInstrumentation();
    const sources = productLines(ring?.id);
    const target = productRingCount(ring?.id) + amount;
    assertTarget(ring, target, sources);
    const token = transactionToken();
    const additions = bundleItems(ring, amount).map(item => ({
      ...item, properties: { ...cleanProperties(sources[0]), _wtm_offer_tx: token }
    }));
    const transaction = { kind: 'addition', productId: ring.id, sources: structuredClone(sources), additions, target, token };
    interruptedReplacement = transaction;
    let response;
    try {
      response = await request('cart/add.js', {
        items: additions,
        sections: ['wtm-cart-state'],
        sections_url: ROOT + 'cart'
      });
    } catch (exception) {
      await read(false);
      await settleReplacement();
      if (!transaction.completed) throw exception;
      return target;
    }
    const confirmed = cartFromAddition(response, transaction);
    if (confirmed) adopt(confirmed, false);
    else await read(false);
    await settleReplacement();
    if (!transaction.completed) throw new Error('Your bundle did not finish updating. Please retry.');
    return target;
  }

  // Public offer API: one serialized operation owns bundle replacement and gifts.
  async function addBundle(productId, amount) {
    if (checkingOut) throw new Error('Checkout is opening. Please wait before changing your cart.');
    const ring = rings.get(Number(productId));
    let result;
    const ready = await action(async () => {
      const target = await addRings(ring, Number(amount));
      const bulkTargetUSD = target > 10 ? Math.round(target * ring.offers[9] / 10) : ring.offers[target - 1];
      const nativeUSD = bundleItems(ring, target).reduce((sum, item) =>
        sum + ring.offers[ring.variants.indexOf(item.id)] * item.quantity, 0);
      result = {
        added: true, target, variantId: ring.variants[Math.min(target, 10) - 1],
        variants: bundleItems(ring, target).map(item => ({ variantId: item.id, quantity: item.quantity })),
        expectedUSD: Math.max(nativeUSD, bulkTargetUSD),
        bulkTargetUSD
      };
    }, true, waitForCartInstrumentation);
    if (!ready) throw new Error(error || 'Your cart could not be updated. Please retry.');
    return { ...result, cart };
  }

  async function addVariant(input, trigger) {
    const id = Number(input?.id);
    const quantity = Number(input?.quantity ?? 1);
    const properties = input?.properties ?? {};
    if (!Number.isSafeInteger(id) || id < 1 ||
        !Number.isSafeInteger(quantity) || quantity < 1 ||
        typeof properties !== 'object' || Array.isArray(properties) ||
        Object.entries(properties).some(([key, value]) => !key || typeof value !== 'string')) {
      throw unchangedError('Choose a valid product option before adding it to your cart.');
    }
    if (checkingOut) throw new Error('Checkout is opening. Please wait before changing your cart.');
    mount();
    if (!el) throw unchangedError('Your cart is not ready. Please reload and try again.');
    const addition = { id, quantity, properties: { ...properties } };
    const ready = await action(async () => {
      const matchingQuantity = () => cart.items.reduce((total, item) =>
        total + (same(item, addition) ? item.quantity : 0), 0);
      const target = matchingQuantity() + quantity;
      let failure;
      try {
        await request('cart/add.js', { items: [addition] });
      } catch (exception) {
        failure = exception;
      }
      await read(false);
      if (matchingQuantity() < target) {
        throw failure || new Error('Your item did not finish updating. Please review your cart before trying again.');
      }
    }, true, waitForCartInstrumentation);
    if (!ready) throw new Error(error || 'Your cart could not be updated. Please retry.');
    open();
    if (trigger?.isConnected && typeof trigger.focus === 'function') returnFocus = trigger;
    return { added: true, variantId: id, quantity, cart };
  }

  function operate(button) {
    const kind = button.dataset.wtmAction;
    const key = button.dataset.key;

    const requestedProtection = kind === 'protection'
      ? button.checked
      : null;

    if (kind === 'close') {
      close();
      return;
    }

    if (button.disabled || pending || checkingOut) return;

    if (kind === 'retry') {
      refresh(true);
      return;
    }

    focusAfterUpdate = {
      action: kind,
      key,
      product: cart.items.find(
        item => item.key === key
      )?.product_id
    };

    action(async () => {
      if (kind === 'upsell') {
        const ring = [...rings.values()].find(ring => ring.variants[0] === Number(button.dataset.variant));
        await addRings(ring, 1);
        return;
      }

      if (kind === 'protection') {
        const preference = requestedProtection ? 'on' : 'off';
        const intended = {
          ...cart, attributes: { ...cart.attributes, [PREF]: preference }
        };
        // Save the opt-in and its line quantity together. update.js returns
        // the full confirmed cart; reconcile still verifies all prices/gifts.
        adopt(await request('cart/update.js', {
          updates: managedUpdates(intended),
          attributes: { [PREF]: preference }
        }), false);
        return;
      }

      const item = cart.items.find(
        item => item.key === key
      );

      if (!item) {
        throw new Error(
          'This item changed while your cart was updating. Please try again.'
        );
      }

      if (kind === 'remove') {
        adopt(await request('cart/change.js', {
          id: item.key,
          quantity: 0
        }), false);

        return;
      }

      if (birthstoneSelections(item)) return;
      const direction = kind === 'plus' ? 1 : -1;
      const ring = rings.get(Number(item.product_id));

      const count = ring
        ? productRingCount(ring.id)
        : item.quantity;

      // Minus at one removes the item.
      if (direction < 0 && count <= 1) {
        adopt(await request('cart/change.js', {
          id: item.key,
          quantity: 0
        }), false);

        return;
      }

      if (!ring) {
        adopt(await request('cart/change.js', {
          id: item.key,
          quantity: Math.max(0, item.quantity + direction)
        }), false);

        return;
      }

      // Merge compatible legacy lines, retaining their exact physical ring count.
      const sources = productLines(ring.id);
      const next = productRingCount(ring.id) + direction;
      if (direction > 0) await addRings(ring, direction);
      else await replaceProduct(ring, sources, next);
    }, true, kind === 'plus' || kind === 'upsell' ? waitForCartInstrumentation : undefined);
  }

  function isCartPage() {
    const path = new URL(location.href).pathname.replace(/\/+$/, '');
    const cartPath = new URL(ROOT + 'cart', location.origin).pathname.replace(/\/+$/, '');
    return path === cartPath || path === '/cart';
  }

  function smoothScroller() {
    // This theme declares `const lenis` in a classic script, not window.lenis.
    // It can still be in its temporal dead zone while the page is being parsed.
    try {
      const instance = window.lenis || (typeof lenis !== 'undefined' ? lenis : null);
      return instance && typeof instance.stop === 'function' &&
        typeof instance.start === 'function' ? instance : null;
    } catch (_) {
      return null;
    }
  }

  function lockCartScroll() {
    if (scrollLock) return;
    const body = document.body;
    const root = document.documentElement;
    const computed = getComputedStyle(body);
    const scroller = smoothScroller();
    const gap = Math.max(0, window.innerWidth - root.clientWidth);
    const properties = ['position', 'top', 'left', 'right', 'width', 'padding-right'];
    scrollLock = {
      x: window.scrollX,
      y: window.scrollY,
      scroller,
      resume: Boolean(scroller && !scroller.isStopped),
      fixed: computed.position !== 'fixed',
      styles: properties.map(name => [name, body.style.getPropertyValue(name), body.style.getPropertyPriority(name)])
    };
    if (scrollLock.resume) scroller.stop();
    if (scrollLock.fixed) {
      body.style.setProperty('position', 'fixed', 'important');
      body.style.setProperty('top', `-${scrollLock.y}px`, 'important');
      body.style.setProperty('left', `-${scrollLock.x}px`, 'important');
      body.style.setProperty('right', 'auto', 'important');
      body.style.setProperty('width', '100%', 'important');
      if (gap) body.style.setProperty('padding-right', `${(parseFloat(computed.paddingRight) || 0) + gap}px`, 'important');
    }
    root.classList.add('wtmc-open');
    body.classList.add('wtmc-open');
  }

  function releaseCartScroll() {
    const state = scrollLock;
    scrollLock = null;
    document.documentElement.classList.remove('wtmc-open');
    document.body.classList.remove('wtmc-open');
    if (!document.body.classList.contains('wtm-menu-open') &&
        !document.querySelector('.side-drawer.show:not(#cart-side-drawer)')) {
      document.body.classList.remove('no-scroll');
    }
    if (!state) return;
    if (state.fixed) {
      state.styles.forEach(([name, value, priority]) => {
        if (value) document.body.style.setProperty(name, value, priority);
        else document.body.style.removeProperty(name);
      });
      const style = document.documentElement.style;
      const behavior = style.getPropertyValue('scroll-behavior');
      const priority = style.getPropertyPriority('scroll-behavior');
      style.setProperty('scroll-behavior', 'auto', 'important');
      window.scrollTo(state.x, state.y);
      if (behavior) style.setProperty('scroll-behavior', behavior, priority);
      else style.removeProperty('scroll-behavior');
    }
    // Resynchronize the theme's scroll position before resuming its animation.
    if (state.resume) {
      state.scroller.scrollTo?.(state.y, { immediate: true, force: true });
      state.scroller.start();
    }
  }

  function onDrawerWheel(event) {
    if (!openState || event.ctrlKey) return; // Preserve browser/trackpad zoom.
    event.stopPropagation();
    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    if (target?.closest('.wtmc-upsell-rail') && Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
    const local = target?.closest('.wtmc-scroll, .wtmc-footer');
    const scrollable = local && el.contains(local) ? local : null;
    const dy = event.deltaY;
    if (scrollable && dy && (
      (dy < 0 && scrollable.scrollTop > 0) ||
      (dy > 0 && scrollable.scrollTop + scrollable.clientHeight < scrollable.scrollHeight - 1)
    )) return; // Let the browser scroll this region natively.

    // A reached edge or backdrop must never pass its wheel movement to the PDP.
    if (event.cancelable) event.preventDefault();
    const panel = target?.closest('.wtmc-panel');
    if (!panel || (scrollable && scrollable.scrollHeight > scrollable.clientHeight + 1)) return;
    const content = $('[data-wtm-scroll]');
    if (!content || !dy) return;
    const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? content.clientHeight : 1;
    // Wheel gestures over the fixed header/summary move the item list, too.
    content.scrollTop += dy * unit;
  }

  function bindDrawerScroll() {
    scrollEvents?.abort();
    scrollEvents = new AbortController();
    const signal = scrollEvents.signal;
    el.addEventListener('wheel', onDrawerWheel, { passive: false, signal });
    let touch = null;
    el.addEventListener('touchstart', event => {
      const point = event.touches.length === 1 ? event.touches[0] : null;
      touch = openState && point ? { x: point.clientX, y: point.clientY } : null;
    }, { passive: true, signal });
    el.addEventListener('touchmove', event => {
      if (!openState) return;
      event.stopPropagation();
      if (event.touches.length !== 1 || !touch) return;
      const point = event.touches[0];
      const dx = point.clientX - touch.x;
      const dy = point.clientY - touch.y;
      touch = { x: point.clientX, y: point.clientY };
      const target = event.target instanceof Element ? event.target : event.target.parentElement;
      if (target?.closest('.wtmc-upsell-rail') && Math.abs(dx) > Math.abs(dy)) return;
      if (!dy) return;
      const region = target?.closest('.wtmc-scroll, .wtmc-footer');
      if (region && el.contains(region)) {
        const limit = Math.max(0, region.scrollHeight - region.clientHeight);
        const next = region.scrollTop - dy;
        if (next > 0 && next < limit) return;
        if (event.cancelable) {
          event.preventDefault();
          region.scrollTop = Math.max(0, Math.min(limit, next));
        }
      } else if (event.cancelable) {
        event.preventDefault();
      }
    }, { passive: false, signal });
    const clearTouch = () => { touch = null; };
    el.addEventListener('touchend', clearTouch, { passive: true, signal });
    el.addEventListener('touchcancel', clearTouch, { passive: true, signal });
  }

  function reflectOpen() {
    // Keep the drawer mounted as the cart page's engine, but never display
    // its modal there—even if a legacy theme script adds the show class.
    if (isCartPage()) {
      if (el.classList.contains('show')) el.classList.remove('show');
      openState = false;
      el.setAttribute('aria-hidden', 'true');
      el.inert = true;
      releaseCartScroll();
      return;
    }

    const next = el.classList.contains('show');

    if (next === openState) return;

    openState = next;
    el.setAttribute('aria-hidden', String(!next));
    el.inert = !next;

    if (next) {
      returnFocus = document.activeElement;
      lockCartScroll();

      requestAnimationFrame(() => {
        $('.wtmc-close')?.focus({
          preventScroll: true
        });
      });

      if (Date.now() - lastRead > 1000) {
        refresh();
      }
    } else {
      releaseCartScroll();

      if (
        returnFocus?.isConnected &&
        !el.contains(returnFocus)
      ) {
        returnFocus.focus({
          preventScroll: true
        });
      }
    }
  }

  function open() {
    if (!el) return;
    if (isCartPage()) {
      reflectOpen();
      document.querySelector('#wtm-cart-page h1')?.focus({ preventScroll: true });
      return;
    }
    el.classList.add('show');
    reflectOpen();
  }

  function close() {
    if (!el) return;
    el.classList.remove('show');
    reflectOpen();
  }

  let saleObserver, saleSource;
  const saleNodes = new WeakMap();
  function saleSeconds(source) {
    if (!source || source.hidden || source.hasAttribute('data-pending')) return null;
    if (typeof source.remainingSeconds === 'function') return source.remainingSeconds();
    const parts = ['hours', 'minutes', 'seconds'].map(part =>
      source.querySelector(`[data-${part}]`)?.textContent.trim()
    );
    if (!/^\d{1,3}$/.test(parts[0] || '') ||
        !parts.slice(1).every(part => /^[0-5]\d$/.test(part || ''))) return null;
    const seconds = Number(parts[0]) * 3600 + Number(parts[1]) * 60 + Number(parts[2]);
    if (!source.dataset.end?.trim()) {
      const duration = source.dataset.duration || '';
      if (!/^\d{1,3}:[0-5]\d:[0-5]\d$/.test(duration)) return null;
      const values = duration.split(':').map(Number);
      if (seconds > values[0] * 3600 + values[1] * 60 + values[2] + 1) return null;
    }
    return seconds;
  }
  function syncSale() {
    const target = $('[data-wtm-sale]');
    if (!target) return;
    const source = document.querySelector('wtm-sale-countdown');
    const bar = source?.closest('wtm-sale-announcement, [id^="WtmSaleBar-"]');
    const title = bar?.querySelector('.wtm-sale-bar__heading')?.textContent.trim();
    const remaining = saleSeconds(source);
    target.hidden = !ringCount(cart || {items:[]}) || !title || remaining === null || Boolean(bar?.hidden);
    if (target.hidden) return;
    let nodes = saleNodes.get(target);
    if (!nodes || nodes.label.parentNode !== target || nodes.time.parentNode !== target || target.childNodes.length !== 2) {
      nodes = {label: document.createTextNode(''), time: document.createElement('time')};
      nodes.value = document.createTextNode('');
      nodes.time.append(nodes.value);
      target.replaceChildren(nodes.label, nodes.time);
      saleNodes.set(target, nodes);
    }
    const label = `${title} ends in `;
    const value = [Math.floor(remaining / 3600), Math.floor((remaining % 3600) / 60), remaining % 60]
      .map(part => String(part).padStart(2, '0')).join(':');
    if (nodes.label.data !== label) nodes.label.data = label;
    if (nodes.value.data !== value) nodes.value.data = value;
  }
  function bindSale() {
    const source = document.querySelector('wtm-sale-countdown')?.closest('wtm-sale-announcement, [id^="WtmSaleBar-"]');
    if (source !== saleSource) {
      saleObserver?.disconnect(); saleSource = source;
      if (source) { saleObserver = new MutationObserver(syncSale); saleObserver.observe(source, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['hidden']}); }
    }
    syncSale();
  }
  document.addEventListener('DOMContentLoaded', bindSale);
  window.addEventListener('load', bindSale);
  document.addEventListener('shopify:section:load', bindSale);

  function mount() {
    const next = document.querySelector(
      'wtm-cart-drawer#cart-side-drawer'
    );

    if (!next || next === el) return;

    observer?.disconnect();
    el = next;
    bindDrawerScroll();

    try {
      market = JSON.parse($('[data-wtm-market]').textContent);
      market.currency = String(market.currency || 'USD').toUpperCase();
      market.shopCurrency = String(market.shopCurrency || 'USD').toUpperCase();
      catalog = new Map(
        JSON.parse($('[data-wtm-catalog]').textContent)
          .map(product => [
            Number(product.id),
            product
          ])
      );

      const hugModel = rows[5];
      for (const product of catalog.values()) {
        const id = Number(product.id);
        const variants = product.bundleVariants;
        if (product.bundleModel !== 'hug' || rings.has(id) || !Array.isArray(variants) ||
            variants.length !== hugModel[2].length ||
            !variants.every(value => Number.isSafeInteger(value) && value > 0) ||
            new Set(variants).size !== variants.length) continue;
        rings.set(id, {
          id,
          title: product.title,
          variants,
          offers: hugModel[3],
          retail: hugModel[4],
          image: product.image,
          index: rows.indexOf(hugModel)
        });
      }

      if (!cart) {
        const initial = JSON.parse($('[data-wtm-initial]').textContent);
        if (!Array.isArray(initial?.items) || typeof initial.total_price !== 'number') {
          throw new Error('Invalid initial cart.');
        }
        cart = initial;
      }
    } catch (_) {
      error = 'Your cart could not load. Please retry.';
      needsRecovery = true;
      if (!cart) cart = { items: [], total_price: 0, currency: 'USD' };
    }

    el.inert = !el.classList.contains('show');
    openState = !el.classList.contains('show');

    observer = new MutationObserver(reflectOpen);

    observer.observe(el, {
      attributes: true,
      attributeFilter: ['class']
    });

    render();
    bindSale();
    reflectOpen();
  }

  // Keep each carousel's heading aligned with its most visible ring.
  const pendingUpsellRails = new WeakSet();
  document.addEventListener('scroll', event => {
    const rail = event.target instanceof Element ? event.target : null;
    if (!rail?.matches('.wtmc-upsell-rail') ||
        !rail.closest('#cart-side-drawer, wtm-cart-page') ||
        pendingUpsellRails.has(rail)) return;
    pendingUpsellRails.add(rail);
    requestAnimationFrame(() => {
      pendingUpsellRails.delete(rail);
      if (!rail.isConnected) return;
      const heading = rail.parentElement?.querySelector('.wtmc-upsell-heading .wtmc-label');
      const bounds = rail.getBoundingClientRect();
      if (!heading || bounds.width <= 0) return;
      let active = null;
      let mostVisible = 0;
      for (const card of rail.children) {
        const box = card.getBoundingClientRect();
        const visible = Math.max(0, Math.min(box.right, bounds.right) - Math.max(box.left, bounds.left));
        if (visible > mostVisible) { active = card; mostVisible = visible; }
      }
      const reason = active?.dataset.wtmUpsellReason;
      if (reason && heading.textContent !== reason) heading.textContent = reason;
    });
  }, { capture: true, passive: true });

  document.addEventListener('click', event => {
    const target = event.target instanceof Element
      ? event.target
      : null;

    if (!target) return;

    const arrow = target.closest('[data-wtm-slide]');
    if (arrow && el?.contains(arrow)) {
      event.preventDefault(); event.stopImmediatePropagation();
      const rail = $('.wtmc-upsell-rail');
      rail?.scrollBy({left:Number(arrow.dataset.wtmSlide) * ((rail.firstElementChild?.getBoundingClientRect().width || rail.clientWidth) + 10),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      return;
    }
    const button = target.closest('[data-wtm-action]');

    if (
      button &&
      el?.contains(button) &&
      button.type !== 'checkbox'
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
      operate(button);
      return;
    }

    // Use the existing theme header cart icon.
    const trigger = target.closest('a,button');

    if (
      !trigger ||
      !trigger.closest('.wtm-header,header')
    ) return;

    const href = trigger.getAttribute('href');
    let cartLink = false;

    try {
      const link = href && new URL(href, location.origin);
      cartLink = link && link.origin === location.origin &&
        link.pathname.replace(/\/+$/, '') ===
          new URL(ROOT + 'cart', location.origin).pathname.replace(/\/+$/, '');
    } catch (_) {}

    if (
      href === '#cart-side-drawer' ||
      cartLink ||
      trigger.getAttribute('aria-controls') === 'cart-side-drawer'
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
      open();
    }
  }, true);

  document.addEventListener('change', event => {
    if (
      event.target.matches?.(
        '[data-wtm-action="protection"]'
      ) &&
      el?.contains(event.target)
    ) {
      event.stopImmediatePropagation();
      operate(event.target);
    }
  }, true);

  function resetCheckout() {
    clearTimeout(checkoutTimer);
    checkoutAttempt++;
    checkingOut = false;
    navigating = false;
    setControls();
  }

  async function checkout() {
    if (pending || checkingOut) return;

    clearTimeout(refreshTimer);
    checkingOut = true;
    const attempt = ++checkoutAttempt;
    setControls();
    $('[data-wtm-status]').textContent = 'Checking your cart before checkout.';

    try {
      const ready = await action(async () => {}, true);
      if (attempt !== checkoutAttempt) return;
      if (!ready || needsRecovery || !visibleItems(cart).length) return;

      const form = $('[data-wtm-checkout-form]');
      if (!form?.isConnected) throw new Error('Checkout could not open. Please try again.');

      navigating = true;
      setControls();
      $('[data-wtm-status]').textContent = 'Opening secure checkout.';

      // If the browser stays on this page, release the checkout lock visibly.
      // This one-shot timer is cleared on pagehide and history restoration.
      checkoutTimer = setTimeout(() => {
        if (attempt !== checkoutAttempt) return;
        resetCheckout();
        error = 'Checkout has not opened. Please try again.';
        showError();
      }, 10000);

      // Native Shopify cart POST with the hidden checkout input. No recursive
      // submit event, AJAX cart wrapper, or disabled-button omission.
      HTMLFormElement.prototype.submit.call(form);
    } catch (exception) {
      if (attempt !== checkoutAttempt) return;
      navigating = false;
      error = exception?.message || 'Checkout could not open. Please try again.';
      showError();
    } finally {
      if (attempt === checkoutAttempt && !navigating) resetCheckout();
    }
  }

  document.addEventListener('submit', event => {
    if (!event.target.matches?.('[data-wtm-checkout-form]') ||
        !el?.contains(event.target)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    void checkout();
  }, true);

  document.addEventListener('keydown', event => {
    if (!openState) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      close();
      return;
    }

    if (event.key !== 'Tab') return;

    const nodes = Array.from(
      el.querySelectorAll(
        'button:not(:disabled),a[href],input:not(:disabled),summary,[tabindex="0"]'
      )
    ).filter(node => (
      node.getClientRects().length &&
      node.tabIndex >= 0
    ));

    const first = nodes[0];
    const last = nodes[nodes.length - 1];

    if (
      event.shiftKey &&
      (
        document.activeElement === first ||
        !el.contains(document.activeElement)
      )
    ) {
      event.preventDefault();
      last?.focus();
    } else if (
      !event.shiftKey &&
      (
        document.activeElement === last ||
        !el.contains(document.activeElement)
      )
    ) {
      event.preventDefault();
      first?.focus();
    }
  }, true);

  /*
    Serialize product-page cart requests alongside drawer requests.
    Non-cart requests pass straight through.
  */
  window.fetch = function(input, options) {
    if (options?.[internalRequest]) return downstreamFetch(input, options);
    let url;
    let method;

    try {
      url = new URL(
        input instanceof Request
          ? input.url
          : String(input),
        location.href
      );

      method = String(
        options?.method ||
        (
          input instanceof Request
            ? input.method
            : 'GET'
        )
      ).toUpperCase();
    } catch (_) {
      return downstreamFetch(input, options);
    }

    if (
      url.origin !== location.origin ||
      method !== 'POST' ||
      !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/(add|change|update|clear)(?:\.js)?$/i
        .test(url.pathname)
    ) {
      return downstreamFetch(input, options);
    }

    if (checkingOut) {
      return Promise.reject(new Error('Checkout is opening. Please wait before changing your cart.'));
    }

    return enqueue(async () => {
      lastMutation = Date.now();
      try {
        const { response, value } = await cartTransport(input, options, async response => ({
          response,
          value: response.ok ? await response.clone().json().catch(() => null) : null
        }), downstreamFetch);

        if (response.ok) {
          error = '';
          try {
            if (typeof value?.total_price === 'number') adopt(value, false);
            else await read(false);
            await settleReplacement();
            await reconcile();
            needsRecovery = false;
            render();
          } catch (exception) {
            await recover(exception);
          }
        }
        return response;
      } catch (exception) {
        await recover(exception);
        throw exception;
      } finally {
        lastMutation = Date.now();
      }
    });
  };

  const externalChange = () => {
    mount();

    if (Date.now() - lastMutation > 1000) {
      refresh();
    }
  };

  [
    'cart:updated',
    'cart:refresh',
    'cart:change',
    'cart-updated',
    'theme:cart:change'
  ].forEach(name => {
    document.addEventListener(
      name,
      externalChange
    );
  });

  [
    'product:added',
    'ajaxProduct:added'
  ].forEach(name => {
    document.addEventListener(name, () => {
      externalChange();
      open();
    });
  });

  // Observe XHR integrations without replacing XMLHttpRequest.
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(list => {
        const changed = list.getEntries().some(entry => {
          try {
            const url = new URL(entry.name);

            return (
              entry.initiatorType === 'xmlhttprequest' &&
              url.origin === location.origin &&
              /\/cart\/(add|change|update|clear)(?:\.js)?$/
                .test(url.pathname)
            );
          } catch (_) {
            return false;
          }
        });

        if (changed) refresh(true);
      }).observe({
        type: 'resource',
        buffered: false
      });
    } catch (_) {}
  }

  window.addEventListener('pagehide', () => {
    clearTimeout(checkoutTimer);
  });

  window.addEventListener('pageshow', event => {
    // Safari may restore this exact JS heap, including the old checkout flag.
    const wasCheckingOut = checkingOut;
    resetCheckout();
    if (event.persisted || wasCheckingOut) {
      needsRecovery = true;
      setControls();
      refresh(true);
    }
  });

  document.addEventListener(
    'shopify:section:load',
    () => {
      mount();
      refresh(true);
    }
  );

  window.WTMCartDrawer = {
    version: 'bulk-cart-2026-10-11',
    addBundle,
    addVariant,
    open,
    close,
    refresh: () => refresh(true),
    mount
  };

  if (!customElements.get('wtm-cart-drawer')) {
    customElements.define(
      'wtm-cart-drawer',
      class extends HTMLElement {
        connectedCallback() {
          queueMicrotask(mount);
        }
        disconnectedCallback() {
          queueMicrotask(() => {
            if (this !== el || this.isConnected) return;
            observer?.disconnect();
            scrollEvents?.abort();
            openState = false;
            releaseCartScroll();
            el = null;
          });
        }
      }
    );
  }

  mount();
})();



